import CountWords from '@/src/components/CountWords/CountWords';
import { useSingleImageEffect } from '@/src/components/Upload';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import { Input } from 'src/components/Antd';
import { Uploader } from 'src/components/Upload';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

//import _ from 'lodash';
const MiniProgramShare = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { image, onImageChange, text, onTextChange, disabled, hideEdit } =
    props;

  const [fileList, setFileList] = React.useState(image ? [image] : []);
  useSingleImageEffect(image, fileList, setFileList);

  const handleImageChange = (list: Array<any>) => {
    const length = list.length;
    const image = length ? list[length - 1] : null;
    setFileList(list);
    onImageChange(image);
  };

  const handleContentChange = (text) => {
    onTextChange(text);
  };

  return (
    <div className={css.container}>
      <Section>
        <ItemWrapper
          //   error={(imgErr || []).length > 0}
          //   errorText={(imgErr || []).join(' ')}
          title={getI18n('general.shareCoverImage')}
          bottomTitle={getI18n('general.shareCoverImageTip')}>
          <Uploader
            multiple={false}
            height={180}
            fileList={fileList}
            disabled={disabled}
            onChange={handleImageChange}
            hideEdit={hideEdit}
          />
        </ItemWrapper>

        <ItemWrapper
          title={getI18n('general.shareTitle')}
          rightPart={<CountWords count={(text || '').length} allCount={100} />}>
          <Input
            // error={(textErr || []).length > 0}
            // help={(textErr || []).join(' ')}
            size={'large'}
            // className={css.input}
            placeholder={getI18n('general.shareTitle')}
            maxLength={100}
            fullyControlledFilter={(v) => v}
            value={text}
            disabled={disabled}
            onChange={handleContentChange}
          />
        </ItemWrapper>
      </Section>
    </div>
  );
};
export default MiniProgramShare;
